<rask-page pageTitle="Jobb" noPadding>
  <rask-container-block>
    <div>
      <div>
        <rask-button (click)="refresh()">Uppdatera {{ (service.autoRefreshActive$ | async) ? '('+(secondDelay-secondsPassed)+')' : ''}}</rask-button>
      </div>
      <div>
        <rask-checkbox text="Uppdatera var {{ secondDelay }} sekund" [checked]="(service.autoRefreshActive$ | async)" (checkedChange)="onAutoRefreshChange($event)">
        </rask-checkbox>
      </div>
      <div class="ms-3 mt-3">
        Senast uppdaterad {{ latestRefresh | date: 'medium'}}
      </div>
    </div>
    <rask-list [data]="jobbLista" [useClientFilter]="true" clientFilterResultText="jobb typer">
      <rask-list-column header="Typ" field="typ" [sortable]="true"></rask-list-column>
      <rask-list-column header="Antal feluppehåll" field="antalFelUppehall">
        <ng-template let-row="row">
          <div>
            <a [routerLink]="['/jobb', row.typ, 'FelUppehall']">
              {{ row.antalFelUppehall }}
            </a>
          </div>
        </ng-template>
      </rask-list-column>
      <rask-list-column header="Antal fel" field="antalFel">
        <ng-template let-row="row">
          <div>
            <a [routerLink]="['/jobb', row.typ, 'Fel']">
              {{ row.antalFel }}
            </a>
          </div>
        </ng-template>
      </rask-list-column>
      <rask-list-column header="Antal behandlas" field="antalBehandlas">
        <ng-template let-row="row">
          <div>
            <a [routerLink]="['/jobb', row.typ, 'Behandlas']">
              {{ row.antalBehandlas }}
            </a>
          </div>
        </ng-template>
      </rask-list-column>
      <rask-list-column header="Antal i kö (schemalagda)" field="antalNy">
        <ng-template let-row="row">
          <div>
            {{ row.antalNy }} @if (row.antalSchemalagda) {
            <span>({{ row.antalSchemalagda }})</span>
          }
        </div>
      </ng-template>
    </rask-list-column>
  </rask-list>
</rask-container-block>
</rask-page>